module.exports = __webpack_public_path__ + "media/warranty-claim/photos-back-house-db0e0f15.png";